var map = {
	"./ch.png": 8446,
	"./dp.png": 3429,
	"./kh.png": 5435,
	"./kher.png": 511,
	"./kyiv.png": 3444,
	"./od.png": 8158,
	"./pl.png": 7346,
	"./zh.png": 2841
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1127;